import React from "react";

import styles from "./styles.modules.scss";

export const TimeUnit = ({
    timeUnit: { value, unit },
}: {
    timeUnit: { value: number; unit: string };
}) => (
    <div className={`time-unit ${styles.timeUnit}`}>
        <div className={`value ${styles.value}`}>{value}</div>

        <div className={`unit ${styles.unit}`}>{unit}</div>
    </div>
);
